import React from "react";
import { Link } from "react-router-dom";

import styles from "../Home/home.module.scss";

const News = () => {
  return (
    <section className={styles["news-section"]} id="news">
      <h2 className={styles["headings"]}>News</h2>

      <div className={styles["news-content"]}>
        <p
          className={styles["news-paragraphs"]}
          style={{ color: "red", fontWeight: "bold", marginBottom: "10px" }}
        >
          Nachdem es am Freitag (25.09.2026) leider, aus technischen Gründen,
          nicht möglich war, die Anmeldung für den Ferienkurs wie geplant
          durchzuführen, nun folgende Verfahrensweise.
        </p>

        <p
          className={styles["news-paragraphs"]}
          style={{ color: "red", fontWeight: "bold", marginBottom: "10px" }}
        >
          Alle Interessenten, welche sich gern für den annoncierten Kurs
          anmelden möchten, schreiben bitte ihre Anfrage an{" "}
          <a
            className={styles["email-link"]}
            href="mailto:j.seeberger@fsheideteam.de"
            alt="email link to info"
            target="_blank"
            rel="noopener noreferrer"
          >
            j.seeberger@fsheideteam.de
          </a>{" "}
          – ich werde mich bemühen, alle Anfragen so gut es geht zu bearbeiten.
          <br />
          Ich bitte um Verständnis!
        </p>

        {/* _____ Urgent section above to remove _____ */}

        <p className={styles["news-paragraphs"]}>
          Liebe zukünftige Fahrschülerinnen und Fahrschüler,
        </p>
        <p className={styles["news-paragraphs"]}>
          <span style={{ textDecoration: "underline" }}>Zeitraum</span>:
          <span className={styles["bold-text"]}> 19.10.2026 - 24.10.2026 </span>
          (Montag - Samstag → jeweils von 9.00 - 12.00 Uhr).
        </p>
        <p className={styles["news-paragraphs"]}>
          Achtung! Die letzte Lektion findet am{" "}
          <span className={styles["bold-text"]}>28.10.2026</span> von 18.00 -
          21.00 Uhr statt.
        </p>
        <p className={styles["news-paragraphs"]}>
          Auch wenn es die Darstellung in den Medien vielleicht anders vermuten
          lässt, aber in der aktuellen Gesetzgebung gilt eine vollständige
          Anwesenheit über den gesamten Kurszeitraum.
        </p>
        <p className={styles["news-paragraphs"]}>
          Aus betrieblich-organisatorischen Gründen können wir keine Ausnahmen
          zulassen oder Ersatztermine anbieten. Bitte stellt im Voraus sicher,
          dass ihr zu allen Unterrichtszeiten anwesend sein könnt.
        </p>
        <p className={`${styles["news-paragraphs"]} ${styles["bold-text"]}`}>
          Der Kurs ist nur für die Klasse B/BF17 buchbar.
        </p>
        <p className={styles["news-paragraphs"]}>
          Dabei ist zu beachten, dass aus rechtlichen Gründen eine Anmeldung nur
          möglich ist, wenn ihr im nächsten halben Jahr (vom 20.10.2026
          gerechnet) das gesetzliche Mindestalter (17 Jahre bei BF17 oder 18
          Jahre bei Klasse B) erreicht habt.
        </p>
        <p className={styles["news-paragraphs"]}>
          Die Anzahl der Plätze für diesen Kurs beschränkt sich auf{" "}
          <span className={styles["bold-text"]}>14 Ausbildungsplätze</span>.
        </p>
        <p className={styles["news-paragraphs"]}>
          Am{" "}
          <span className={styles["bold-text"]}>
            25.09.2026 wird um 18.00 Uhr
          </span>{" "}
          eine Mailadresse{" "}
          <a
            className={styles["email-link"]}
            href="mailto:anmeldung@fsheideteam.de"
            alt="email link to info"
            target="_blank"
            rel="noopener noreferrer"
          >
            anmeldung@fsheideteam.de
          </a>{" "}
          freigeschaltet. Sind diese 14 Plätze vergeben, werden wir diese
          Mailadresse leider sofort wieder vom Netz nehmen.
        </p>
        <p className={styles["news-paragraphs"]}>
          Wir bitten um Verständnis! Aufgrund der hohen Nachfrage ist es uns
          leider nicht mehr möglich, dieses Verfahren anders zu gestalten. Es
          sollte jeder eine faire Chance haben.
        </p>
        <p className={styles["news-paragraphs"]}>Mit besten Grüßen,</p>
        <p
          className={styles["news-paragraphs"]}
          style={{ fontStyle: "italic" }}
        >
          Eure Heideteam Fahrschule
        </p>

        <hr />
        <p
          className={styles["news-paragraphs"]}
          style={{ paddingTop: "1.7rem" }}
        >
          Hier noch ein Auszug aus der aktuellen Preisliste (Klasse B) laut
          Fahrlehrergesetz:
          <br />
          <div
            style={{
              textAlign: "left",
              paddingLeft: "6.5rem",
              paddingBottom: "1rem",
              paddingTop: "1rem",
            }}
          >
            <ul>
              <li>Grundbetrag 650 € (ink. Lehrmaterial)</li>
              <li>Übungsfahrt je 45 Minuten 63 €</li>
              <li>Sonderfahrt je 45 Minuten 75 €</li>
              <li>Vorstellung zur theoretischen Prüfung 50 €</li>
              <li>
                Vorstellung zur praktischen Prüfung 165 € (jeweils ohne DEKRA
                Gebühren)
              </li>
            </ul>
          </div>
        </p>

        <hr />
        <p
          className={styles["news-paragraphs"]}
          style={{ paddingTop: "1.7rem" }}
        >
          Bitte informieren Sie sich in unserem Büro (jeweils mittwochs von
          15.00 - 18.00 Uhr) oder jederzeit per Mail unter:
          <a
            className={styles["email-link"]}
            href="mailto:info@fsheideteam.de"
            alt="email link to info"
            target="_blank"
            rel="noopener noreferrer"
          >
            <br /> info@fsheideteam.de
          </a>
          .
        </p>
        <p className={styles["news-paragraphs"]}>
          Zum Abklären weiterer Fragen sprechen Sie uns einfach an!
        </p>
        <div className={styles["news-contact-button-container"]}>
          <Link smooth to="/kontakt" className={styles["news-contact-button"]}>
            Kontakt
          </Link>
        </div>
      </div>
      {/* <div className={styles["dividing-line"]}></div> */}
    </section>
  );
};

export default News;
